import { WGSL_VERTEXINPUT_STRUCT_NAME, WGSL_VERTEXOUTPUT_STRUCT_NAME, WGSL_INTERACTIONDATA_STRUCT_NAME } from '../constants';
//namespace Pacem.Drawing3D.WebGPU {
const defaultVertexGeometryModifierArgs = ['input', 'data'];
//const defaultVertexGeometryModifier: VertexInputModifierDelegate = (...defaultVertexGeometryModifierArgs) => {
//    const [inputRef, dataRef] = defaultVertexGeometryModifierArgs;
//    return `fn echo(${inputRef}: ${WGSL_VERTEXINPUT_STRUCT_NAME}, ${dataRef}: ${WGSL_INTERACTIONDATA_STRUCT_NAME}) -> ${WGSL_VERTEXINPUT_STRUCT_NAME} { return ${inputRef}; }`;
//};
export function extractMeshVertexModifierFunctionComponents(wgsl) {
    if (typeof wgsl !== 'string') {
        wgsl = wgsl(...defaultVertexGeometryModifierArgs);
    }
    // regex that remove all the wgsl comments and extract the function name, arguments and body
    const regex = new RegExp(`fn\\s+(\\w+)\\s*\\(([^)]*)\\)\\s*->\\s*(${WGSL_VERTEXINPUT_STRUCT_NAME}|${WGSL_VERTEXOUTPUT_STRUCT_NAME})\\s*{((.|\\n)+)}\\s*$`);
    const match = wgsl.match(regex);
    if (match) {
        const name = match[1];
        const args = match[2].split(',').map(arg => {
            const kvp = arg.split(':');
            return { name: kvp[0].trim(), type: kvp[1].trim() };
        });
        if (args.length !== 2
            || args[0].type !== match[3] // the first argument type must match the function return type
            || args[1].type !== WGSL_INTERACTIONDATA_STRUCT_NAME) {
            throw new Error(`Invalid modifier function. Invalid signature types (arg1: ${args[0]?.type}, arg2: ${args[1]?.type})`);
        }
        const body = match[4].trim();
        return { name, args: args.map(i => i.name), body };
    }
    else {
        throw new Error(`Invalid modifier function. Must be a valid WGSL function with the signature: fn name(arg1: ${WGSL_VERTEXINPUT_STRUCT_NAME}|${WGSL_VERTEXOUTPUT_STRUCT_NAME}, arg2: ${WGSL_INTERACTIONDATA_STRUCT_NAME}) -> ${WGSL_VERTEXINPUT_STRUCT_NAME}|${WGSL_VERTEXOUTPUT_STRUCT_NAME}`);
    }
}
